import { useTranslation } from "react-i18next";

export default function PreviousInfluencerLinkShortcut({
  previousInfluencerLink,
  onUse,
}: {
  previousInfluencerLink?: string;
  onUse: (link: string) => void;
}) {
  const { t } = useTranslation();

  // 后端没有返回上次合作链接时，提示、链接和快捷填充按钮必须整体隐藏。
  if (!previousInfluencerLink) return null;

  return (
    // Figma 3764:6011：快捷区域是单行 14/20 文案。
    <div className="flex w-full items-center justify-between gap-4 font-['Inter'] text-sm font-normal leading-5">
      <div className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-[#525252]">
        {t("common.influencerTrackLinkModal.previousLinkHint")}{" "}
        <a
          href={previousInfluencerLink}
          target="_blank"
          rel="noreferrer"
          className="text-[#2563EB] hover:text-[#1D4ED8]"
        >
          {previousInfluencerLink}
        </a>
      </div>
      <button
        type="button"
        className="w-[81px] shrink-0 cursor-pointer border-0 bg-transparent p-0 text-right font-['DM_Sans'] text-sm font-semibold leading-5 text-[#EC470A] hover:text-[#C4320A]"
        onClick={() => onUse(previousInfluencerLink)}
      >
        {t("common.influencerTrackLinkModal.usePreviousLink")}
      </button>
    </div>
  );
}
